import datacentral from '@/utils/axios/datacentral'

const getBaseNameAndExtension = (fileName: string) => {
    const lastDotIndex = fileName.lastIndexOf('.')
    let baseName: string
    let ext: string
    if (lastDotIndex === -1) {
        baseName = fileName
        ext = ''
    } else {
        baseName = fileName.slice(0, lastDotIndex)
        ext = fileName.slice(lastDotIndex + 1)
    }
    return { baseName, ext }
}

const AddSuffixToFile = (existedFiles: string[], uploadedFiles: File[]) => {
    const existed = new Set(existedFiles.map((file) => file.split('/').pop()))

    return uploadedFiles.map((file) => {
        const { baseName, ext } = getBaseNameAndExtension(file.name)
        let name = file.name
        let suffixCount = 0

        while (existed.has(name)) {
            suffixCount++
            name = `${baseName} (${suffixCount}).${ext}`
        }

        existed.add(name)
        return new File([file], name, {
            type: file.type,
            lastModified: file.lastModified,
        })
    })
}

// Add suffix for folders
const AddSuffixToFolder = (
    existedFolders: string[],
    uploadedFolders: File[]
) => {
    const existed = new Set(
        existedFolders.map((folder) => folder.split('/').filter(Boolean).pop())
    )
    const suffixMap = new Map<string, string>()

    return uploadedFolders.map((folder) => {
        const baseName = folder.name.split('/')[0]
        let name = baseName

        if (existed.has(name)) {
            if (!suffixMap.has(baseName)) {
                // Find the next available suffix for this base name
                let suffixCount = 1
                while (existed.has(`${baseName} (${suffixCount})`)) {
                    suffixCount++
                }
                suffixMap.set(baseName, ` (${suffixCount})`)
            }
            name = baseName + suffixMap.get(baseName)!
        }

        existed.add(name)
        return new File(
            [folder],
            `${name}/${folder.name.split('/').slice(1).join('/')}`,
            {
                type: folder.type,
                lastModified: folder.lastModified,
            }
        )
    })
}

export const AddSuffix = (
    existedFiles: string[],
    existedFolders: string[],
    uploadedFiles: File[]
) => {
    const files = uploadedFiles.filter((file) => !file.name.includes('/'))
    const folders = uploadedFiles.filter((file) => file.name.includes('/'))
    return [
        ...AddSuffixToFile(existedFiles, files),
        ...AddSuffixToFolder(existedFolders, folders),
    ]
}

export const CheckConflict = async (
    object_keys: string[],
    prefix: string
): Promise<boolean> => {
    const response = await datacentral.post('/drive/conflict/check', {
        object_keys,
        prefix,
    })
    return response.data.result
}

export const ListObjectKeys = async (
    prefix: string,
    type: 'file' | 'folder'
): Promise<string[]> => {
    const response = await datacentral.get('/drive/keys', {
        params: { prefix, type },
    })
    return response.data.results || []
}
